import { configureStore } from '@reduxjs/toolkit';

import { listenerMiddleware } from './listenerMiddleware';
import newMessagesReducer from '../features/new_messages'
import ownerReducer from '../features/owners/ownerSlice'
import messageThreadReducer from '../features/messageThreads/messageThreadSlice'
import messageReducer from '../features/messages/messageSlice'
import userReducer from '../features/users/userSlice'

const store = configureStore({
  reducer: {
    new_messages: newMessagesReducer,
    owners: ownerReducer,
    messageThreads: messageThreadReducer,
    messages: messageReducer,
    users: userReducer
  },

  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .prepend(listenerMiddleware.middleware)
});

export default store;
